import CompLayout from "@/pcomponents/comp/layout/layout";

function CoolenMainPage(){


  const go_coolen_main_page=()=>{
    let get_data_str="?token_id="+localStorage.intoyou_token;
    let url_str=process.env.REACT_APP_API_URL+"/home/cool_en/login"+get_data_str;
    location.href=url_str;
  };

  return (
    <CompLayout >
      <div className="center">
        <button className="btn btn-dark" 
         onClick={()=>{
          go_coolen_main_page();
         }} >학습하러가기</button>
      </div>
    </CompLayout>
  );
}

export default CoolenMainPage;